// © 2015-2021 WDNA - All Rights Reserved

import api, { AxiosRequestConfig } from '../../../services/api/Connect';

export * from './types';

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function adjustment<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('adjustment/list', data, options);
    case 'get':
      return id ? api.get(`adjustment/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('adjustment/set', data, options);
    case 'del':
      return id ? api.get(`adjustment/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function firmware<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('firmware/list', data, options);
    case 'get':
      return id ? api.get(`firmware/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('firmware/set', data, options);
    case 'del':
      return id ? api.get(`firmware/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function sensor<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'set':
      return api.post('sensor/set', data, options);
    case 'del':
      return id ? api.get(`sensor/del/${id}`, data, options) : undefined;
    case 'get':
      return id ? api.get(`sensor/get/${id}`, data, options) : undefined;
    case 'list':
      return api.post('sensor/list', data, options);
    case 'update':
      return api.post('sensor/update', data, options);
    case 'alerts':
      return api.get('sensor/alerts', data, options);
    case 'statistics':
      return id ? api.get(`sensor/statistics/${id}`, data, options) : undefined;
    case 'copy':
      return api.get('sensor/register/copy', data, options);
    case 'register_get':
      return id ? api.get(`sensor/register/get/${id}/${data.timestamp}`, data, options) : undefined;
    case 'register_list':
      return id ? api.get(`sensor/register/list/${id}`, data, options) : undefined;
    case 'register_graph':
      return id ? api.get(`sensor/register/graph/${id}`, data, options) : undefined;
    case 'register_lasts':
      return api.get('sensor/register/lasts', data, options);
    case 'gis_position':
      return api.post('sensor/gis/position', data, options);
    case 'gis_tracking':
      return id ? api.get(`sensor/gis/tracking/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function waste<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('waste/list', data, options);
    case 'get':
      return id ? api.get(`waste/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('waste/set', data, options);
    case 'del':
      return id ? api.get(`waste/del/${id}`, data, options) : undefined;
    case 'infos':
      return id ? api.get(`waste/infos/${id}`, data, options) : undefined;
    case 'info':
      return id ? api.post(`waste/info/${id}`, data, options) : undefined;
    case 'unload_list':
      return api.get('waste/unload/list', data, options);
    case 'unload_graph':
      return api.get('waste/unload/graph', data, options);
    case 'unload_reads':
      return api.get('waste/unload/reads', data, options);
    case 'unload_verify':
      return id ? api.get(`waste/unload/verify/${id}`, data, options) : undefined;
    case 'dashboard':
      return api.get('waste/dashboard', data, options);
    case 'statistics':
      return api.get('waste/statistics', data, options);
    case 'weights':
      return api.get('waste/weights', data, options);
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function weather<T = any>(action: string, id: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'statistics':
      return api.get(`weather/statistics/${id}`, data, options);
    case 'windrose':
      return api.get(`weather/windrose/${id}`, data, options);
    default:
      return undefined;
  }
}
